import { render } from "./scheduleMainPage.vue?vue&type=template&id=0a197005&scoped=true"
import script from "./scheduleMainPage.vue?vue&type=script&lang=js"
export * from "./scheduleMainPage.vue?vue&type=script&lang=js"

import "./scheduleMainPage.vue?vue&type=style&index=0&id=0a197005&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a197005"]])

export default __exports__